import { Form } from "react-bootstrap";
import { useAppSelector } from "../../redux/Store";
import { ITRFilingSelector } from "../../redux/slice/ITRFilingSlice";

const RadioSwitch = ({ onChange, name, id, checked }: any) => {
  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

  return (
    <Form.Group className="form-group" controlId={name}>
      <Form.Switch
        id={id}
        className="label-inside"
        label={checked ? "Yes" : "No"}
        checked={checked}
        name={name}
        onChange={(e) => onChange(e.target.checked)}
        disabled={isFilingReadOnly}
      />
    </Form.Group>
  );
};

export default RadioSwitch;
